
document.addEventListener("DOMContentLoaded", () => {
  const addButtons = document.querySelectorAll("[data-add-btn]");
  const qualifyButton = document.querySelector("[data-qualify-link-btn], .custom-form");

  if (!qualifyButton) return; // safety check

  addButtons.forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault(); // ✅ stop default behavior
      qualifyButton.click();  // ✅ trigger qualify button click
    });
  });
});

